import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
    providedIn: 'root'
})

export class RefreshService {

    public notify = new BehaviorSubject<any>('');

    notifyObservable$ = this.notify.asObservable();

    public notifyOther(data: any) {
        if (data) {
            console.log("Refresh Data === " + JSON.stringify(data));
            this.notify.next(data);
        }
    }

}
